module.exports = __webpack_public_path__ + "img/mission-gfp-large.jpg?045c151bd1f215410fa7269834432276";